import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';

const getAmountOfGlassAreas = (
  doors: IGlassWallDoor[],
  wall: IWall
): number => {
  if (wall.onlyDoor) {
    return 1;
  }

  if (doors.length === 0) {
    return 1;
  }

  let amount = doors.length + 1;

  if (doors[0].isFirstDoor) {
    amount -= 1;
  }

  if (doors[doors.length - 1].isLastDoor) {
    amount -= 1;
  }

  return amount;
};

export default getAmountOfGlassAreas;
